import { render, staticRenderFns } from "./BasePlayableAvatar.vue?vue&type=template&id=35314730&scoped=true&"
import script from "./BasePlayableAvatar.vue?vue&type=script&lang=js&"
export * from "./BasePlayableAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35314730",
  null
  
)

component.options.__file = "BasePlayableAvatar.vue"
export default component.exports